module.exports = __webpack_public_path__ + "img/buddy_ears-02.2d696d42.svg";